export const NAME = 'resetPassword';
export const LEVEL_ONE = 'resetPasswordReducer';
